<template>
  <el-dialog :visible.sync="visible" :title="'预选学生设置'" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
    <div class="mod-club__clubTeacher">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
<!--          <el-select v-model="dataForm.gradeId" placeholder="请选择年级" clearable>-->
<!--            <el-option-->
<!--                    v-for="grade in openingObjectGroup"-->
<!--                    :value="grade.id"-->
<!--                    :label="grade.title"-->
<!--                    :key="grade.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.studentName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="studentName" label="学生名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="studentSex" label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.studentSex === sexual.MAN">男</el-tag>
            <el-tag v-else-if="scope.row.studentSex === sexual.WOMAN">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column  header-align="center" align="center" >
          <template slot-scope="scope">
            <el-button v-if="isInArray(scope.row)" size="mini" @click="addCheckedStudent(scope.row)">选中</el-button>
            <el-button v-else=""  type="danger" size="mini" @click="removeCheckedStudent(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { sexual, teacherType } from '../../../constant'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/student/student/page',
        getDataListIsPage: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      checkedStudentList: [],
      checkedStudentNameList: [],
      visible: false,
      teacherType,
      sexual,
      openingObjectGroup: [],
      dataForm: {
        studentName: ''
      }
    }
  },
  methods: {
    init (openingObjectGroup) {
      this.visible = true
      this.query()
      // console.log(openingObjectGroup)
      // this.openingObjectGroup = openingObjectGroup
      // const gradeIds = []
      // openingObjectGroup.forEach((item, index) => {
      //   gradeIds.push(item)
      // })
      // console.log(gradeIds)
      // this.dataForm.gradeIds = gradeIds
      // console.log(this.dataForm.gradeIds)
      // this.$nextTick(() => {
      //   this.getStudentByGradeIds()
      // })
    },
    addCheckedStudent (row) {
      this.checkedStudentList.push(row.id)
      this.checkedStudentNameList.push(row.studentName)
      this.$emit('checkedStudent', [this.checkedStudentList, this.checkedStudentNameList])
    },
    removeCheckedStudent (row) {
      for (let i = 0; i < this.checkedStudentList.length; i++) {
        if (this.checkedStudentList[i] === row.id) {
          this.checkedStudentList.splice(i, 1)
        }
      }
      for (let i = 0; i < this.checkedStudentNameList.length; i++) {
        if (this.checkedStudentNameList[i] === row.studentName) {
          this.checkedStudentNameList.splice(i, 1)
        }
      }
      this.$emit('checkedStudent', [this.checkedStudentList, this.checkedStudentNameList])
    },
    isInArray (row) {
      for (var i = 0; i < this.checkedStudentList.length; i++) {
        if (row.id === this.checkedStudentList[i]) {
          return false
        }
      }
      return true
    }
    // 获取学生
    // getStudentByGradeIds () {
    //   this.$http.get('/student/student/getStudentByGradeIds', this.dataForm.gradeIds).then(({ data: res }) => {
    //     if (res.code !== 0) {
    //       return this.$message.error(res.msg)
    //     }
    //     this.activityTypeList = res.data
    //   }).catch(() => {})
    // }
  },
  components: {
  },
  mounted () {
  }
}
</script>
